/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react"
import Select from "app/static/frontend/selects/components/Select"
import PropTypes from "prop-types"

/**
 * This component renders a select in a cell of a sheet
 * Since we expect the custom field options with the response of the sheet, we do not
 * need to make an asynchronous request to fetch that data
 */

export default class CustomTagSelect extends React.Component {
    loadOptions = () =>
        Object.keys(this.props.options)
            .sort((a, b) => this.props.options[a].order - this.props.options[b].order)
            .filter((each) => !this.props.options[each].archived)
            .map((each) => ({
                id: each,
                value: each,
                label: this.props.options[each].value,
            }))

    render = () => {
        let className = this.props.className || ""
        if (this.props.options && Object.keys(this.props.options) && Object.keys(this.props.options).length > 5) {
            className += " always-scroll"
        }

        return (
            <div
                className="customTagDropdown"
                // neccessary because the Select onClick() event propagates down to the SheetCell onClick() every time we click on a select,
                // which re-calls clickCell() after the unclickCell() action creator is fired in patchColumnData of sheet-action-creators
                // Since it is not possible to pass an onClick prop down to a react-select component, this is necessary
                // https://github.com/JedWatson/react-select/issues/532
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                }}
            >
                <Select loadOptions={this.loadOptions} {...this.props} className={className} />
            </div>
        )
    }
}

CustomTagSelect.propTypes = {
    async: PropTypes.bool,
    multi: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    value: PropTypes.string,
}

CustomTagSelect.defaultProps = {
    async: false,
    label: "label",
    multi: false,
    options: [],
    placeholder: "Select option...",
}
